<h2 class="first_title">Cancelleria Telematica</h2>
<div export-help></div>
<div class="content-page-wrapper">
    <div class="standardpanel">
		<div class="row">
			<!-- <div class="col-xs-12 col-sm-6">
				<a class="card consultazione_anonima" [routerLink]="['consultazione-anonima']">Consultazione anonima</a>
			</div> -->
			<div *ngIf="enableConfig">
				<div *ngFor="let element of config" class="col-xs-12 col-sm-6">
					<a class="card {{element.class}}" href="javascript:void(0)" (click)="onAction(element)">{{element.label}}</a>
				</div>
			</div>
		</div>
	</div>
</div>

